import { IConstructionProgress } from '../../repositories/construction-progress/entities/get_construction_progress_page/ConstructionProgress';
import { IConstructionProgressStage } from '../../types/constructionProgress';
import { prepareImage } from './prepareImage';

export const prepareConstructionProgress = (
  data: IConstructionProgress,
  newbuildingName: string,
): IConstructionProgressStage => {
  return {
    date: data.date,
    images: data.images.map(img => prepareImage(img, newbuildingName, data.date)),
  };
};
